<template>
  <div class="embed-container">
      <div class="viewer">
          Valve title: {{valve.title}}

          <iframe src="" frameBorder="0" :slug="valve.slug" id="api-frame" allowfullscreen mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
      </div>
  </div>
</template>


<script>
    import axios from 'axios'


export default {
  name: 'EmbedView',
  props: ['valve'],
//    data: function() {
//        return {
//            embedID: this.initialEmbedID
//        }
//    },
    methods: {
      loadEmbed(){

            console.log("EMBED LOAD");
            console.log(this.valve.title);


//          var embedData = {};
//          axios.get('https://sketchfab.com/oembed?url=https://sketchfab.com/models/'+this.embedID)
//          .then(function(response){
//              embedData = response.data
//              console.log(embedData);
//
//              var iframeElement = document.querySelectorAll('iframe')[0];
//              var iframeElementParent = iframeElement.parentNode;
//              iframeElementParent.removeChild(iframeElement);
//
//              var embedHTML = embedData.html;
//                var  embedEl = new DOMParser().parseFromString(embedHTML, "text/html");
//
//
//
//              iframeElementParent.appendChild(embedEl.childNodes[0]);
//          });

      }
    },
    created() {
        console.log("CREATED!");
    },
    watch: {
        '$route': 'loadEmbed'
//        // call again the method if the route changes
//        '$route' (to, from) {
//            console.log("LOADING WATCH EMBED")
//           // this.loadEmbed()
//            console.log(this.initialEmbedID);
//        }
    },
    mounted(){
      console.log("MOUNTED!");
       // this.loadEmbed()
       // console.log(this.initialEmbeDID);
    }
}
</script>
